import { createSelector } from 'reselect';
import orderBy from 'lodash/orderBy';
import { COHORTS_SEARCH_PATH, COHORTS_SORT_PATH } from './constants';

const selectCohortList = (state) => state.getIn(['workspaceCohorts', 'cohorts']);
const selectCohort = (state, cohortId) => state.getIn(['workspaceCohorts', 'cohort', cohortId]);
const selectCohortAccounts = (state, cohortId) => state.getIn(['workspaceCohorts', 'cohortAccounts', cohortId]);
const selectCohortCollaborators = (state, cohortId) => state.getIn(['workspaceCohorts', 'cohort', cohortId, 'collaborators']);

const selectCohortsSort = (state) => state.getIn(['workspaceCohorts', COHORTS_SORT_PATH]);
const selectCohortsSearch = (state) => state.getIn(['workspaceCohorts', COHORTS_SEARCH_PATH]);

function orderByType(data = '', type) {
  switch (type) {
    case 'date':
      return Date.parse(data);
    default:
      return data.toLowerCase();
  }
}

const selectSortedCohortList = createSelector(
  [selectCohortList, selectCohortsSort],
  (cohortList, sortDetails) => {
    const sortKey = sortDetails?.key ? sortDetails?.key : 'name';
    const sortOrder = sortDetails?.order ? sortDetails?.order : "asc";
    return orderBy(
        cohortList?.toJS(),
        [(cohort) => orderByType(cohort[sortKey], sortDetails?.type)],
        sortOrder
    );
  });

const selectFilteredCohortList = createSelector(
  [selectSortedCohortList, selectCohortsSearch],
  (sortedCohortList, searchQuery) => searchQuery ?
    sortedCohortList.filter((cohort) => cohort?.name.toLowerCase().includes(searchQuery?.toLowerCase())) :
    sortedCohortList
);

export {
  selectCohortList,
  selectCohortsSort,
  selectCohortsSearch,
  selectFilteredCohortList,
  selectSortedCohortList,
  selectCohort,
  selectCohortAccounts,
  selectCohortCollaborators,
};
